namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_widget_float_table_form, {
		width: '100%',
		height: '100%',
		minWidth: 0,
		minHeight: 0,
		flex: {
			direction: 'column',
		},

		Form_head: {
			flex: { shrink: 0 },
			padding: $mol_gap.block,
			background: {
				color: $mol_theme.card,
			},
			align: {
				items: 'center',
			},
		},

		Form_title: {
			minHeight: '2rem',
			minWidth: 0,
			padding: $mol_gap.text,
			flex: {
				grow: 1,
				shrink: 1,
			},
		},
		Form_title_text: {
			minWidth: 0,
			width: '100%',
			display: 'block',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
		},

		Form: {
			flex: { grow: 1, shrink: 1 },
			minHeight: 0,
			overflow: 'hidden',
			Body: {
				flex: { grow: 1, shrink: 1 },
				minHeight: 0,
				overflow: 'auto',
				padding: {
					left: $mol_gap.block,
					right: $mol_gap.block,
				},
			},
			Foot: {
				flex: { shrink: 0 },
				padding: {
					left: $mol_gap.block,
					right: $mol_gap.block,
					bottom: $mol_style_func.calc( `2 * ${ $mol_gap.block }` ),
				},
			},
		},

		Actions: {
			width: '100%',
			padding: 0,
			justify: {
				content: 'space-between',
			},
		},
		Clear_actions: { flex: { wrap: 'wrap' }, gap: $mol_gap.text },

		Close: {
			flex: {
				shrink: 0,
			},
		},
	} )
	
	$mol_style_define( $shm_hitalama_map_widget_float_table, {

		Select_options: { textAlign: 'left' },
		Cell_table_atom_link: { padding: 0 },
		Cell_table_list_link: { padding: 0 },
		Cell_table_select: { padding: 0 },
		Table_select: { width: '100%' },
		Table_atom_link_content: { width: '100%', maxWidth: '600px', maxHeight: '600px', overflow: 'auto', flexWrap: 'wrap' },
		Table_list_link_content: { width: '100%', maxWidth: '600px', maxHeight: '600px', overflow: 'auto', minWidth: 0, flexWrap: 'wrap' },
		Table_atom_pick: {
			marginLeft: 'auto',
			Trigger: {
				padding: $mol_gap.text,
				justify: { content: 'center' },
			},
		},
		Table_atom_item: { '[selected]': { true: { color: $mol_theme.current } } },
		Table_list_item: {
			whiteSpace: 'nowrap',
			'[selected]': { true: { color: $mol_theme.current } },
		},
		Table_list_create: { '[selected]': { true: { color: $mol_theme.current } } },
		Table_relation_edit_panel: {
			flex: { basis: '30rem', grow: 0, shrink: 0 },
			maxWidth: '42vw',
			minWidth: '20rem',
			minHeight: 0,
			overflow: 'hidden',
			padding: 0,
			background: { color: $mol_theme.back },
			border: { left: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},
		Table_relation_edit_form: { width: '100%', height: '100%', minWidth: 0, minHeight: 0 },

		'[shm_hitalama_map_widget_float_locked]': {
			true: {
				Table: { userSelect: 'text' },
			},
		},

		Workspace: {
			width: '100%',
			minHeight: 0,
			minWidth: 0,
			overflow: 'hidden',
		},

		'[relation_open]': {
			true: {
				Table_panel: { flex: { basis: '30rem', grow: 0, shrink: 0 } },
			},
		},

		Table_panel: {
			flex: {
				direction: 'column',
				grow: 1,
				shrink: 1,
			},
			height: '100%',
			minHeight: 0,
			minWidth: 0,
			position: 'relative',
			overflow: 'hidden',
		},

		Table_scroll: {
			flex: { basis: 0, grow: 1, shrink: 1 },
			minHeight: 0,
			minWidth: 0,
			overflow: 'auto',
		},

		Table_toolbar: {
			padding: 0,
			gap: $mol_gap.text,
			flex: { shrink: 0, wrap: 'wrap' },
			width: '100%',
			minWidth: 0,
			position: 'relative',
			zIndex: 7,
			background: {
				color: $mol_theme.back,
			},
		},

		Query_tools: {
			width: '100%',
			minWidth: 0,
			flex: { wrap: 'wrap' },
			align: { items: 'center' },
		},
		Search: { flex: { grow: 1, shrink: 1 }, minWidth: '10rem' },
		Query_status: { padding: $mol_gap.text },
		Active_filters: { width: '100%', padding: $mol_gap.text, whiteSpace: 'normal', flex: { shrink: 1 } },
		Empty: { padding: $mol_gap.text },
		Grid_row: { '[selected]': { true: { background: { color: $mol_theme.hover } } } },

		Pagination_controls: {
			margin: { left: 'auto' },
			alignSelf: 'center',
			align: { items: 'center' },
		},

		Pagination: {
			align: { items: 'center' },
			justify: { content: 'center' },
		},

		Page_size_label: {
			flex: { direction: 'row' },
			align: { items: 'center' },
			gap: '6px',
			minHeight: 0,
			whiteSpace: 'nowrap',
			Label: { padding: 0, minHeight: 0 },
		},

		Page_size: {
			minHeight: 0,
			margin: { left: '-0.5rem' },
		},

		Pagination_value: {
			align: { items: 'center' },
			justify: { content: 'center' },
		},

		Create_panel: {
			flex: {
				basis: '30rem',
				grow: 0,
				shrink: 0,
			},
			maxWidth: '42vw',
			minWidth: '20rem',
			minHeight: 0,
			overflow: 'hidden',
			padding: 0,
			border: {
				right: {
					width: '1px',
					style: 'solid',
					color: $mol_theme.line,
				},
			},
		},

		Create_form: {
			width: '100%',
			height: '100%',
			minWidth: 0,
			minHeight: 0,
		},

		Edit_panel: {
			flex: {
				basis: '30rem',
				grow: 0,
				shrink: 0,
			},
			maxWidth: '42vw',
			minWidth: '20rem',
			minHeight: 0,
			overflow: 'hidden',
			padding: 0,
			background: {
				color: $mol_theme.back,
			},
			border: {
				left: {
					width: '1px',
					style: 'solid',
					color: $mol_theme.line,
				},
			},
		},

		Edit_form: {
			width: '100%',
			height: '100%',
			minWidth: 0,
			minHeight: 0,
		},

		Cell_copy: {
			display: 'none',
		},

		Copy_area: {
			position: 'absolute',
			top: 0,
			right: 0,
			":hover": {
				['Cell_copy' as '$mol_view']: {
					display: 'block',
				},
			},
		},

		Table: {
			padding: 0,
			overflow: 'visible',
			height: 'fit-content',
			minWidth: 'max-content',
		},

		Table_editor: {
			flex: { grow: 1 },
			minWidth: 0,
			minHeight: 0,
		},

		Table_editor_panel: {
			flex: {
				basis: '30rem',
				grow: 0,
				shrink: 0,
				direction: 'column',
			},
			maxWidth: '42vw',
			minWidth: '20rem',
			minHeight: 0,
			background: { color: $mol_theme.back },
			border: {
				left: {
					width: '1px',
					style: 'solid',
					color: $mol_theme.line,
				},
			},
		},

		Table_editor_head: {
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			align: { items: 'center' },
		},

		Table_editor_title: {
			minHeight: '2rem',
			padding: $mol_gap.text,
			gap: $mol_gap.text,
			flex: {
				grow: 1,
				shrink: 1,
			},
		},

		Table_editor_close: {
			flex: { shrink: 0 },
		},

		Table_editor_content: {
			padding: $mol_gap.block,
			width: '100%',
		},

		Table_schema: {
			minHeight: '10rem',
			textAlign: 'left',
			font: { family: 'monospace' },
		},

		Table_visibility: {
			padding: $mol_gap.text,
		},

		Table_widths: {
			width: '100%',
		},

		Col_head: {
			transition: 'none',
			position: 'sticky',
			top: 0,
			zIndex: 2,
			pointerEvents: 'none',
			':hover': { zIndex: 3 },
			'[pinned]': {
				true: {
					zIndex: 5,
					':hover': { zIndex: 6 },
				},
			},
			background: { color: $mol_theme.back },
			font: {
				weight: 'normal',
			},
		},

		Col_head_content: {
			width: '100%',
			minWidth: 0,
			pointerEvents: 'auto',
			align: { items: 'center' },
			position: 'relative',
			':hover': {
				$mol_pick: {
					opacity: 1,
					pointerEvents: 'auto',
				},
			},
		},

		Col_head_title: {
			flex: { grow: 1, shrink: 1 },
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},

		Col_settings: {
			opacity: 1,
			pointerEvents: 'auto',
			flex: { shrink: 0 },
			align: { items: 'center' },
			Trigger: {
				padding: 0,
				minWidth: '1.5rem',
				minHeight: '1.5rem',
				align: { items: 'center' },
				justify: { content: 'center' },
			},
		},

		Col_settings_bubble: {
			flex: { direction: 'column' },
			minWidth: '18rem',
			maxHeight: '80vh',
			overflow: 'auto',
			padding: 0,
			gap: $mol_gap.block,
			background: { color: $mol_theme.back },
		},

		Cell_text: {
			whiteSpace: 'normal',
			position: 'relative',
			maxWidth: '600px',
		},
		Cell_text_scroll: { maxHeight: '600px', overflow: 'auto' },

		Cell_checkbox: {
			padding: 0,
		},

		Cell_file: {
			padding: 0,
			maxWidth: '600px',
		},
		Cell_file_scroll: { maxHeight: '600px', overflow: 'auto' },

		Cell_file_pb: {
			padding: 0,
			maxWidth: '600px',
		},
		Cell_file_pb_scroll: { maxHeight: '600px', overflow: 'auto' },

		Cell_delete: {
			padding: 0,
		},

		Cell_edit: {
			padding: 0,
		},

		Cell_custom: {
			maxWidth: '600px',
		},
		Cell_custom_scroll: { maxHeight: '600px', overflow: 'auto' },

		Col_custom_code: {
			minHeight: '8rem',
			textAlign: 'left',
			font: {
				family: 'monospace',
			},
		},

		Col_custom_code_help: {
			color: $mol_theme.shade,
			font: {
				size: '0.875rem',
			},
		},

		Delete_column: {
			color: $mol_theme.control,
		},

		Add: {
			position: 'absolute',
			pointerEvents: 'auto',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			minWidth: 0,
			padding: 0,
			align: {
				items: 'center',
			},
			justify: {
				content: 'center',
			},
			border: {
				radius: 0,
			},
			'[active]': {
				true: {
					color: $mol_theme.current,
				},
			},
		},

		Action_edit: {
			'[active]': {
				true: {
					color: $mol_theme.current,
				},
			},
		},

		Edit_table: {
			'[active]': {
				true: {
					color: $mol_theme.current,
				},
			},
		},

		Add_row: {
			'[active]': {
				true: {
					color: $mol_theme.current,
				},
			},
		},
		
		Download: {
			whiteSpace: 'normal',
			maxWidth: '100%',
			overflow: 'hidden',
		},

		Download_pb: {
			maxWidth: '100%',
			overflow: 'hidden',
		},

		All_check: {
			margin: {
				top: '-0.5rem',
				bottom: '-0.5rem',
				left: '-0.75rem',
				right: '-0.75rem',
			},
		},

		Col_width_title: {
			flex: {
				grow: 1,
			},
			align: {
				items: 'center',
			},
			padding: $mol_gap.text,
		},

		Col_widths_head: {
			justify: {
				content: 'flex-end'
			},
			padding: $mol_gap.text,
		},
		
	} )
	
}
